const LabelConsensus = {
  AGREE: 'AGREE',
  DISAGREE: 'DISAGREE',
} as const;
export type LabelConsensusE = typeof LabelConsensus[keyof typeof LabelConsensus];

export default LabelConsensus;
